import selectPipelineConfiguration from './selectPipelineConfiguration';

export default function resolvePipelineConfiguration({ deployedPipeline, configuredPipeline } = {}) {
  return {
    ...selectPipelineConfiguration(deployedPipeline),
    ...selectPipelineConfiguration(configuredPipeline),
  };
}
